const resources = {
    seeMore: 'Consulter d’autres évaluations qui mentionnent',
    modalTitle: 'Hautement évalué par les clients pour'
};

module.exports = function getResource(label) {
    return resources[label];
};
